import { GetterTree } from 'vuex';
import { NodeSamlSession, NodeSamlState } from './types';
import { RootState } from '../../../types';
import { AppContext } from '../../../context';

const getSamlSession = () => (): NodeSamlSession | null => {
    return JSON.parse(localStorage.getItem(AppContext.InternalConfig.LocalStorage.AUTH_NODE_SAML_KEY));
};

export const getters: GetterTree<NodeSamlState, RootState> = {
    samlSession: getSamlSession,
};
